import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo9 } from "../../../routes/Module9";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo9/rree.png";
import Imagen2 from "../../../images/modulo9/defensa.png";
import Imagen3 from "../../../images/modulo9/economia.png";
import Imagen4 from "../../../images/modulo9/interior.png";
import Imagen5 from "../../../images/modulo9/justicia.png";
import Imagen6 from "../../../images/modulo9/educacion.png";
import Imagen7 from "../../../images/modulo9/salud.png";
import Imagen8 from "../../../images/modulo9/agricultura.png";
import Imagen9 from "../../../images/modulo9/trabajo.png";
import Imagen10 from "../../../images/modulo9/produccion.png";
import Imagen11 from "../../../images/modulo9/turismo.png";
import Imagen12 from "../../../images/modulo9/energia.png";
import Imagen13 from "../../../images/modulo9/transporte.png";
import Imagen14 from "../../../images/modulo9/vivienda.png";
import Imagen15 from "../../../images/modulo9/mujer.png";
import Imagen16 from "../../../images/modulo9/ambiente.png";
import Imagen17 from "../../../images/modulo9/cultura.png";
import Imagen18 from "../../../images/modulo9/desarrollo.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo9/Actividad 5.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo9.content[0];
  const infoAct = modulo9.content[0].activities[4];
  const crumbs = [
    {
      title: modulo9.title,
      url: "/" + modulo9.url,
    },
    {
      title:
        modulo9.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo9.content[0].activities[5].name}`,
    linkNext: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[5].path}`,
    titlePrev: `${modulo9.content[0].activities[3].name}`,
    linkPrev: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[3].path}`,
  };
  const metadata = {
    color: modulo9.color,
    title: `${modulo9.title} - ${infoAct.name}`,
    name: modulo9.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo9.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-8 col-12 p-0">
          <ul>
            <li>
              Luego de ser elegido, el Presidente nombra a los ministros que lo
              ayudarán a gobernar. Cada ministro trabaja en algún ámbito
              importante para el país.
            </li>
            <li>
              Observa las imágenes que representan a cada ministerio y conversa
              con un compañero, compañera o familiar.
            </li>
          </ul>
          <div className="ms-3">
            <p>¿Cuántos ministerios hay?</p>
            <p>¿De qué se encarga cada uno?</p>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen1} alt="ministerio" className="img-fluid" />
          <div className="text-center">Relaciones Exteriores</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen2} alt="ministerio" className="img-fluid" />
          <div className="text-center">Defensa</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen3} alt="ministerio" className="img-fluid" />
          <div className="text-center">Economía y Finanzas</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen4} alt="ministerio" className="img-fluid" />
          <div className="text-center">Interior</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen5} alt="ministerio" className="img-fluid" />
          <div className="text-center">Justicia y Derechos Humanos</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen6} alt="ministerio" className="img-fluid" />
          <div className="text-center">Educación</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen7} alt="ministerio" className="img-fluid" />
          <div className="text-center">Salud</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen8} alt="ministerio" className="img-fluid" />
          <div className="text-center">Agricultura y Riego</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen9} alt="ministerio" className="img-fluid" />
          <div className="text-center">Trabajo y Promoción del Empleo</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen10} alt="ministerio" className="img-fluid" />
          <div className="text-center">Producción</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen11} alt="ministerio" className="img-fluid" />
          <div className="text-center">Comercio Exterior y Turismo</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen12} alt="ministerio" className="img-fluid" />
          <div className="text-center">Energía y Minas</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen13} alt="ministerio" className="img-fluid" />
          <div className="text-center">Transportes y Comunicaciones</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen14} alt="ministerio" className="img-fluid" />
          <div className="text-center">
            Vivienda, Construcción y Saneamiento
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen15} alt="ministerio" className="img-fluid" />
          <div className="text-center">Mujer y Poblaciones Vulnerables</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen16} alt="ministerio" className="img-fluid" />
          <div className="text-center">Ambiente</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen17} alt="ministerio" className="img-fluid" />
          <div className="text-center">Cultura</div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
          <img src={Imagen18} alt="ministerio" className="img-fluid" />
          <div className="text-center">Desarrollo e Inclusión Social</div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y observen las imágenes. Ayude explicando los
          ámbitos de trabajo que resulten difíciles: por ejemplo, Defensa se
          ocupa de proteger el territorio peruano e Interior se ocupa del orden
          interno; el MIDIS intenta sacar de la pobreza a la gente y el
          Ministerio de la Mujer protege a poblaciones en peligro.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
